<template>
    <div>
        <DownloadCsv :data="items" :name="file" :labels="csvLabels" delimiter=";" v-if="items.length > 0">
            <v-btn color="success" small>
                <v-icon small> download </v-icon>
                Download em CSV
            </v-btn>
        </DownloadCsv>
        <v-btn @click="generate" color="success" small :loading="loading" :disabled="loading" v-else>
            <v-icon small left> create_new_folder </v-icon>
            {{ label }}
        </v-btn>
    </div>
</template>

<script>
import DownloadCsv from "vue-json-csv";

export default {
    components: { DownloadCsv },

    name: "ExportButton",

    props: {
        label: {
            type: String,
            default: "Exportar",
        },
        file: {
            type: String,
            default: "export.csv",
        },
        endpoint: {
            type: String,
            default: undefined,
        },
        csvLabels: {
            type: Object,
            default: undefined,
        },
    },

    data() {
        return {
            loading: false,
            items: []
        };
    },

    methods: {
        generate() {
            if (this.endpoint) {
                this.loading = true;

                this.$http
                    .get(this.endpoint).then((result) => {
                        this.items = result;
                    }).catch((error) => {
                        this.items = [];
                        this.$eventHub.$emit("msgError", error.message ? error.message : `Erro ao buscar informações para exportar.`);
                    }).finally(() => {
                        this.loading = false;
                    });
            } else {
                this.$eventHub.$emit("msgError", "Não foi possível exportar os dados.");
            }
        }
    }
};
</script>